import { EUserType, TPayloadNotification } from "@deltasge/marauders-map";

export const getUrlFromNotification = (payload: TPayloadNotification) => {
  let url: string | undefined;
  let tipoUsuario: EUserType | undefined;
  if (payload.fromId) {
    const deltaIdParts = payload.fromId.split("-");
    if (deltaIdParts.at(1)) tipoUsuario = deltaIdParts.at(1) as EUserType;
  }
  if (payload.modulo) {
    let modulo = payload.modulo;
    if (modulo == "mensagens") {
      modulo = "publicacoes/recebida";
      if (
        tipoUsuario &&
        [EUserType.Aluno, EUserType.LoginExtra, EUserType.Responsavel].includes(
          tipoUsuario
        )
      ) {
        modulo = "publicacoes/detalhes";
      }
    }
    url = `${modulo}/${payload.id}`;
    if (!url.startsWith("/")) url = `/${url}`;
  }

  if (payload.url) {
    url = payload.url;
  }

  return url;
};
